// Helpers
import { transformDateToLocalDateString } from "helpers";

// Servisni sloj
import {
  VEHICLE_LOCATION_TYPE_CONFIG,
  getVehicleLocationTypeInitials,
} from "services/api/fleet/vehicles/locations/consts";
import { VehicleLocation } from "services/api/fleet/vehicles/locations/types";
import { FleetVehicleStatusEnum } from "services/api/fleet/vehicles/types";

// UI
import Badge from "ui/components/Badge/Badge";
import { ButtonMenu } from "ui/components/Button/ButtonMenu";
import ButtonMenuItem from "ui/components/Button/ButtonMenu/ButtonMenuItem";
import TableIcon from "ui/components/Table/TableSearch/components/TableIcon";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import VehicleStatusBadge from "ui/modules/fleet/vehicles/pages/components/VehicleStatusEditCard/components/VehicleStatusBadge";

export const FLEET_VEHICLE_TRANSFER_SEARCH_COLUMNS = (
  onDeleteClick: (event: React.MouseEvent<HTMLDivElement>, id: string) => void
): Column[] => [
  {
    title: "",
    key: "transfer_icon",
    alwaysVisible: true,
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => (
      <TableIcon initials={getVehicleLocationTypeInitials(row.locationType)} />
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.name",
    key: "transfer_name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => (
      <div className="text-md font-medium text-slate-900 truncate">
        {row.name || "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.type",
    key: "transfer_type",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => {
      const config = row.locationType
        ? VEHICLE_LOCATION_TYPE_CONFIG[row.locationType]
        : null;

      return (
        <span className="text-sm text-slate-600">{config?.label ?? "-"}</span>
      );
    },
  },
  {
    title: "admin.fleet.vehicle.transfer.search.location",
    key: "transfer_location",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => (
      <div className="text-md font-medium text-slate-600 truncate">
        {row.locationName ?? "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.validfrom",
    key: "transfer_validfrom",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => (
      <div className="text-sm text-slate-900">
        {row.validFrom ? transformDateToLocalDateString(row.validFrom) : "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.validuntil",
    key: "transfer_validuntil",
    field: "",
    type: ColumnTypes.custom,
    // Aktivna lokacija nema kraj — umjesto crtice se označi da vozilo još uvijek ondje.
    render: (row: VehicleLocation) =>
      row.isActive ? (
        <Badge text="Trenutno" variant="success" height="small" showDot />
      ) : (
        <div className="text-sm text-slate-900">
          {row.validUntil ? transformDateToLocalDateString(row.validUntil) : "-"}
        </div>
      ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.driver",
    key: "transfer_driver",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => (
      <div className="text-sm text-slate-900 truncate">{row.driverName ?? "-"}</div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.status",
    key: "transfer_status",
    field: "",
    type: ColumnTypes.custom,
    // Popunjeno samo kad je premještaj došao uz promjenu statusa.
    render: (row: VehicleLocation) =>
      row.vehicleStatus ? (
        <VehicleStatusBadge
          status={row.vehicleStatus as FleetVehicleStatusEnum}
          showDropdownIcon={false}
        />
      ) : (
        <div className="text-sm text-slate-400">-</div>
      ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.note",
    key: "transfer_note",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => (
      <div className="text-sm text-slate-900 truncate max-w-[220px]">
        {row.note || "-"}
      </div>
    ),
  },
  {
    title: "admin.fleet.vehicle.transfer.search.usercreated",
    key: "transfer_usercreated",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => (
      <div className="text-sm text-slate-500 truncate">
        {row.userCreatedName ?? "-"}
      </div>
    ),
  },
  {
    title: "",
    key: "transfer_actions",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleLocation) => (
      <ButtonMenu
        endIcon="/media/icons/more-dots.svg"
        cssClassName="h-full"
        variant="text"
      >
        <ButtonMenuItem
          startIcon="/media/icons/trash.svg"
          variant="remove"
          className="text-slate-600 hover:bg-blue-100"
          onClick={(e) => onDeleteClick(e, row.id ?? "")}
        >
          Obriši
        </ButtonMenuItem>
      </ButtonMenu>
    ),
  },
];
